export const BOOK_CONSTANTS = {
    TESTIMONIALS_HEADING: 'Testimonials',
    TESTIMONIALS_REGION_LABEL: 'Book testimonials',
    ADD_TESTIMONIAL: '+ Add Testimonial',
    ADD_TESTIMONIAL_FORM_HEADING: 'Add Testimonial',
    EDIT_TESTIMONIAL_FORM_HEADING: 'Edit Testimonial',
    NO_TESTIMONIALS: 'No testimonials yet.',
    EDIT: 'Edit',
    DELETE: 'Delete',
    CANCEL: 'Cancel',
    SUBMIT: 'Submit',
    REVIEWER_NAME_LABEL: 'Reviewer Name:',
    REVIEWER_TITLE_LABEL: 'Reviewer Title:',
    QUOTE_LABEL: 'Quote:',
    EDIT_ARIA: 'Edit testimonial from',
    DELETE_ARIA: 'Delete testimonial from',
    TESTIMONIAL_ADDED: 'Testimonial added successfully',
    TESTIMONIAL_UPDATED: 'Testimonial updated successfully',
    TESTIMONIAL_REMOVED: 'Testimonial removed successfully',
    NO_CHANGES: 'No changes made'
};

export const TESTIMONIALS_COLLECTION = 'testimonials';
export const BOOKS_COLLECTION = 'books';
